import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';

import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { ApiProvider, AuthProvider, CerebroThemeProvider } from './shared/context';

const queryClient = new QueryClient();

ReactDOM.render(
	<React.StrictMode>
		<CerebroThemeProvider>
			<BrowserRouter>
				<QueryClientProvider client={queryClient}>
					<AuthProvider>
						<ApiProvider>
							<App />
						</ApiProvider>
					</AuthProvider>
					<ReactQueryDevtools />
				</QueryClientProvider>
			</BrowserRouter>
		</CerebroThemeProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, passcl a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

declare global {
	interface Window {
		_mfq: any;
	}
}

if (process.env.REACT_APP_CEREBRO_ENVIRONMENT === 'Production') {
	window._mfq = window._mfq || [];
	(function () {
		var mf = document.createElement('script');
		mf.type = 'text/javascript';
		mf.defer = true;
		mf.src = '//cdn.mouseflow.com/projects/8c8a168e-f5e6-4b43-ac7c-54c5f694d367.js';
		document.getElementsByTagName('head')[0].appendChild(mf);
	})();
}
